// Orderliness (Saturn): a word whose letters come in alphabetical order
// scores more (a repeated letter keeps the order).
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { lettersOf } from '../shared/letters';
import type { AlignmentDef } from '../types';

export function inAlphabeticalOrder(word: string): boolean {
  const letters = lettersOf(word);
  for (let i = 1; i < letters.length; i++) if (letters[i]!.localeCompare(letters[i - 1]!) < 0) return false;
  return true;
}

export const orderliness: AlignmentDef = {
  id: 'orderliness',
  planet: 'saturn',
  name: 'Orderliness',
  text: () => `Words whose letters are in alphabetical order score +${N.orderlinessPercent}%.`,
  wordPercent: (c) => (inAlphabeticalOrder(c.word) ? N.orderlinessPercent : 0),
};
